"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[328],{

/***/ 78934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DO": function() { return /* binding */ ArticleWrapper; },
/* harmony export */   "Fo": function() { return /* binding */ ArticleCategory; },
/* harmony export */   "Ml": function() { return /* binding */ ArticleBody; },
/* harmony export */   "S5": function() { return /* binding */ ArticlesContainer; },
/* harmony export */   "U2": function() { return /* binding */ AuthorName; },
/* harmony export */   "Ul": function() { return /* binding */ Ul; },
/* harmony export */   "d7": function() { return /* binding */ AuthorInfo; },
/* harmony export */   "dg": function() { return /* binding */ ArticleInfo; },
/* harmony export */   "es": function() { return /* binding */ ArticleCategoryLink; },
/* harmony export */   "iA": function() { return /* binding */ Table; },
/* harmony export */   "j1": function() { return /* binding */ ArticleTitle; },
/* harmony export */   "rb": function() { return /* binding */ ReadTimeInfo; },
/* harmony export */   "tt": function() { return /* binding */ ArticlePrimaryImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30815);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78922);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87646);
/* harmony import */ var _lendi_ui_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87856);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border-radius: 6px;\n  @media (max-width: 48rem) {\n    width: calc(100% + (var(--lendi-ui-size) * 3));\n    margin: 0 calc(var(--lendi-ui-size) * -1.5);\n    border-radius: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 48rem;\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        " {\n    max-width: calc(100% + (var(--lendi-ui-size) * 3));\n  }\n  img:not(",
        ") {\n    width: 100%;\n    border-radius: 6px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  text-decoration: none;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  cursor: pointer;\n  text-transform: uppercase;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 600;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  > p:first-child {\n    ",
        "\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  > li {\n    ",
        "\n  }\n  ul {\n    border: none;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  overflow-x: auto;\n  border-collapse: collapse;\n  ",
        "\n\n  th, td {\n    border-bottom: 1px solid ",
        ";\n    ",
        "\n    ",
        "\n  }\n\n  td {\n    ",
        "\n    font-weight: 400;\n    text-align: center;\n    vertical-align: middle;\n  }\n\n  td:first-child {\n    font-weight: 600;\n    text-align: left;\n  }\n\n  tr:last-child td {\n    border: none;\n  }\n\n  th {\n    ",
        "\n    font-weight: 600;\n    text-align: center;\n    border: none;\n  }\n\n  th:first-child {\n    text-align: left;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}




var ArticlesContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6b21b453-0"
})(_templateObject(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.px)({
    mobile: "sm",
    desktop: "xxs"
}));
var ArticlePrimaryImage = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-6b21b453-1"
})(_templateObject1());
var ArticleWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6b21b453-2"
})(_templateObject2(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.mx)("auto"), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.mb)("xl"), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.px)({
    mobile: "md",
    desktop: "xxs"
}), ArticlePrimaryImage, ArticlePrimaryImage);
var ArticleCategoryLink = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-6b21b453-3"
})(_templateObject3(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.mt)({
    mobile: "md",
    desktop: "nil"
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.mb)("xs"));
var ArticleCategory = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-6b21b453-4"
})(_templateObject4(), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_3__/* .body */ .d1)({
    size: "xs",
    color: "primary.500"
}));
var ArticleTitle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-6b21b453-5"
})(_templateObject5(), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_3__/* .heading */ .nP)({
    size: "lg"
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.mt)("nil"), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.mb)("md"));
var ArticleInfo = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-6b21b453-6"
})(_templateObject6(), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_3__/* .body */ .d1)({
    size: "xs"
}), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_1__.fg)("shade.500"), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.mb)("md"));
var AuthorInfo = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-6b21b453-7"
})(_templateObject7(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.mr)("xxxs"));
var AuthorName = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-6b21b453-8"
})(_templateObject8());
var ReadTimeInfo = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-6b21b453-9"
})(_templateObject9(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.ml)("xxxs"));
var ArticleBody = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6b21b453-10"
})(_templateObject10(), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_3__/* .body */ .d1)({
    size: "md"
}), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_3__/* .body */ .d1)({
    size: "lg"
}));
var Ul = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-6b21b453-11"
})(_templateObject11(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.px)("lg"), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$)("shade.100"), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$)("shade.100"), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.my)("xs"));
var Table = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    componentId: "sc-6b21b453-12"
})(_templateObject12(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.my)("sm"), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$)("primary.500"), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.py)("xxs"), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.px)("md"), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_3__/* .body */ .d1)({
    size: "sm",
    color: "shade.700"
}), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_3__/* .body */ .d1)({
    size: "xs",
    color: "primary.500"
}));


/***/ }),

/***/ 27057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B7": function() { return /* binding */ ShortOverview; },
/* harmony export */   "Bc": function() { return /* binding */ Figure; },
/* harmony export */   "ER": function() { return /* binding */ Summary; },
/* harmony export */   "EW": function() { return /* binding */ OverviewFigure; },
/* harmony export */   "Ij": function() { return /* binding */ CategoryLink; },
/* harmony export */   "Jt": function() { return /* binding */ Alink; },
/* harmony export */   "Qw": function() { return /* binding */ FigureLink; },
/* harmony export */   "S3": function() { return /* binding */ Author; },
/* harmony export */   "WD": function() { return /* binding */ Category; },
/* harmony export */   "X6": function() { return /* binding */ Heading; },
/* harmony export */   "YL": function() { return /* binding */ BlogInfo; },
/* harmony export */   "d2": function() { return /* binding */ Article; },
/* harmony export */   "d7": function() { return /* binding */ AuthorInfo; },
/* harmony export */   "g2": function() { return /* binding */ Overview; },
/* harmony export */   "rb": function() { return /* binding */ ReadTimeInfo; },
/* harmony export */   "wC": function() { return /* binding */ OverviewFigureLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30815);
/* harmony import */ var _lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66484);
/* harmony import */ var _lendi_ui_grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35633);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78922);
/* harmony import */ var _lendi_ui_typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87856);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87646);
/* harmony import */ var _lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71386);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n    width: 31%;\n    border: none;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid ",
        ";\n  width: 100%;\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-position: 100% 50%;\n  background-size: cover;\n  border-radius: 6px;\n  height: 100%;\n  ",
        "\n  overflow: hidden;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  height: 216px;\n  overflow: hidden;\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: none;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  text-transform: uppercase;\n  cursor: pointer;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  text-decoration: none;\n  :active {\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  height: 5rem;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-size: cover;\n  background-position: center;\n  border-radius: 3.6px;\n  cursor: pointer;\n  height: 100%;\n  ",
        "\n  overflow: hidden;\n  width: 100%;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n    ",
        "\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 600;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  display: flex;\n  flex-direction: row;\n  flex: 1 0 auto;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}







var Article = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    componentId: "sc-377cb24c-0"
})(_templateObject1(), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$)("shade.100"), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_1__/* .gte */ .eg)("desktop")(_templateObject(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__.mb)("xl")));
var Figure = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].figure.withConfig */ .ZP.figure.withConfig({
    componentId: "sc-377cb24c-1"
})(_templateObject2(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__.m)("nil"));
var FigureLink = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-377cb24c-2"
})(_templateObject3(), function(param) {
    var showSummary = param.showSummary;
    return showSummary ? (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .display */ .jf)({
        mobile: "none",
        desktop: "flex"
    }) : (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .display */ .jf)("flex");
});
var Summary = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-377cb24c-3"
})(_templateObject4());
var CategoryLink = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-377cb24c-4"
})(_templateObject5());
var Category = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-377cb24c-5"
})(_templateObject6(), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_4__/* .body */ .d1)({
    size: "xs",
    color: "primary.500"
}));
var Alink = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-377cb24c-6"
})(_templateObject7(), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_4__/* .link */ .p4)(), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_3__.fg)("shade.700"));
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-377cb24c-7"
})(_templateObject9(), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_4__/* .heading */ .nP)({
    size: "xs"
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__.mt)("nil"), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__.mb)("xs"), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_1__/* .gte */ .eg)("desktop")(_templateObject8(), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_4__/* .heading */ .nP)({
    size: "sm"
})));
var OverviewFigureLink = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-377cb24c-8"
})(_templateObject10(), (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .display */ .jf)({
    mobile: "flex",
    desktop: "none"
}), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_2__/* .unit */ .bf)({
    size: 0.4
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__.m)("nil"));
var OverviewFigure = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].figure.withConfig */ .ZP.figure.withConfig({
    componentId: "sc-377cb24c-9"
})(_templateObject11(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__.m)("nil"));
var ShortOverview = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-377cb24c-10"
})(_templateObject13(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_2__/* .unit */ .bf)({
    offset: 0.1,
    size: 0.6
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__.ml)("sm"), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_1__/* .gte */ .eg)("desktop")(_templateObject12(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_2__/* .unit */ .bf)({
    size: 1
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__.ml)("nil")));
var BlogInfo = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-377cb24c-11"
})(_templateObject14(), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_4__/* .body */ .d1)({
    size: "xs"
}), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_3__.fg)("shade.500"));
var Author = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-377cb24c-12"
})(_templateObject15());
var AuthorInfo = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-377cb24c-13"
})(_templateObject16(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__.mr)("xxxs"));
var ReadTimeInfo = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-377cb24c-14"
})(_templateObject17(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__.ml)("xxxs"));
var Overview = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-377cb24c-15"
})(_templateObject18(), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_4__/* .body */ .d1)({
    size: "md"
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__.my)("sm"));


/***/ }),

/***/ 95622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79894);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _index_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27057);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54422);





var ArticleCard = function(param) {
    var article = param.article, showSummary = param.showSummary;
    var primaryImage = article.primaryImage, slug = article.slug, title = article.title, _category = article.category, category = _category.name, categorySlug = _category.slug, author = article.author, published = article.published, formattedPublished = article.formattedPublished, readTime = article.readTime, shortOverview = article.shortOverview;
    var categoryLink = "/?category=".concat(categorySlug);
    var categoryLinkAs = "/inspire/category/".concat(categorySlug);
    var articleLink = "/article?category=".concat(categorySlug, "&slug=").concat(slug);
    var articleLinkAs = "/inspire/".concat(categorySlug, "/").concat(slug);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_index_style__WEBPACK_IMPORTED_MODULE_3__/* .Article */ .d2, {
        itemScope: true,
        itemType: "http://schema.org/Article",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "datePublished",
                content: published
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "url",
                content: (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .articleUrl */ .MG)(article)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "mainEntityOfPage",
                content: (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .articleUrl */ .MG)(article)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "name",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "headline",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                as: articleLinkAs,
                href: articleLink,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_style__WEBPACK_IMPORTED_MODULE_3__/* .FigureLink */ .Qw, {
                    showSummary: showSummary,
                    target: "_blank",
                    onClick: function() {
                        (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .eventTracking */ .fn)("above-fold", "navigate", "Primary Image (Desktop)");
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_style__WEBPACK_IMPORTED_MODULE_3__/* .Figure */ .Bc, {
                        style: {
                            backgroundImage: "url(".concat(primaryImage, ")")
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_index_style__WEBPACK_IMPORTED_MODULE_3__/* .Summary */ .ER, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        as: categoryLinkAs,
                        href: categoryLink,
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_style__WEBPACK_IMPORTED_MODULE_3__/* .CategoryLink */ .Ij, {
                            target: "_blank",
                            onClick: function() {
                                (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .eventTracking */ .fn)("above-fold", "navigate", category);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_style__WEBPACK_IMPORTED_MODULE_3__/* .Category */ .WD, {
                                children: category
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        as: articleLinkAs,
                        href: articleLink,
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_style__WEBPACK_IMPORTED_MODULE_3__/* .Alink */ .Jt, {
                            target: "_blank",
                            onClick: function() {
                                (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .eventTracking */ .fn)("above-fold", "navigate", title);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_style__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X6, {
                                children: title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_index_style__WEBPACK_IMPORTED_MODULE_3__/* .BlogInfo */ .YL, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_index_style__WEBPACK_IMPORTED_MODULE_3__/* .AuthorInfo */ .d7, {
                                children: [
                                    "By ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_style__WEBPACK_IMPORTED_MODULE_3__/* .Author */ .S3, {
                                        itemProp: "author",
                                        children: author
                                    }),
                                    ","
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
                                dateTime: published,
                                itemProp: "datePublished",
                                children: formattedPublished
                            }),
                            showSummary && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_index_style__WEBPACK_IMPORTED_MODULE_3__/* .ReadTimeInfo */ .rb, {
                                children: [
                                    "| ",
                                    readTime,
                                    " min read"
                                ]
                            })
                        ]
                    }),
                    showSummary && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_index_style__WEBPACK_IMPORTED_MODULE_3__/* .Overview */ .g2, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                as: articleLinkAs,
                                href: articleLink,
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_style__WEBPACK_IMPORTED_MODULE_3__/* .OverviewFigureLink */ .wC, {
                                    target: "_blank",
                                    onClick: function() {
                                        (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .eventTracking */ .fn)("above-fold", "navigate", "Primary Image (Mobile)");
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_style__WEBPACK_IMPORTED_MODULE_3__/* .OverviewFigure */ .EW, {
                                        style: {
                                            backgroundImage: "url(".concat(primaryImage, ")")
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_style__WEBPACK_IMPORTED_MODULE_3__/* .ShortOverview */ .B7, {
                                children: shortOverview
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleCard);


/***/ })

}]);